import { merge, sum } from 'remeda'

import { assert } from '../../assert/assert.js'

export interface DurationParams {
  years: number
  days: number
  hours: number
  minutes: number
  seconds: number
  milliseconds: number
}

export const defaultDurationParams: DurationParams = {
  years: 0,
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  milliseconds: 0,
} as const

const secondToMs = 1000
const minuteToMs = 60 * secondToMs
const hourToMs = 60 * minuteToMs
const dayToMs = 24 * hourToMs
const yearToMs = 365 * dayToMs

export function durationParamsToMs(durationParams: Partial<DurationParams>): bigint {
  const params = merge(defaultDurationParams, durationParams) as DurationParams
  validateParams(params)

  return BigInt(
    sum([
      params.years * yearToMs,
      params.days * dayToMs,
      params.hours * hourToMs,
      params.minutes * minuteToMs,
      params.seconds * secondToMs,
      params.milliseconds,
    ]),
  )
}

function validateParams(params: DurationParams): void {
  for (const [key, value] of Object.entries(params)) {
    assert(value >= 0, `${key} cannot be negative`)
  }
}
